import React from 'react'
import { Label, Input, FormGroup, FormFeedback, InputGroup } from 'reactstrap'
import {
  Controller,
  Control,
  FieldValues,
  FieldErrors,
  UseFormSetValue,
  UseFormGetValues,
} from 'react-hook-form'

const ICSDateInput = ({
  name,
  id = `${name}DateInput`,
  control,
  errors,
  defaultValue = '',
  isSubmitted,
  label,
}: ICSDateInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({
        field: { onChange, onBlur, value, name, ref },
        fieldState: { invalid, isTouched },
      }) => {
        return (
          <FormGroup>
            <Label for={id} className='input-label'>
              {label}
            </Label>
            <InputGroup>
              <Input
                id={id}
                className='ICSDateInput'
                onBlur={onBlur}
                onChange={e => onChange(new Date(e.target.value).toISOString())}
                type='date'
                valid={
                  !invalid &&
                  value !== defaultValue &&
                  (isTouched || isSubmitted)
                }
                placeholder='date...'
                value={value?.split('T')[0] || defaultValue}
                invalid={invalid}
                innerRef={ref}
                data-testid={`${name}DateInput`}
              />

              <FormFeedback
                valid={errors?.[name] ? false : true}
                role='alert'
                id={`${name}Error`}
              >
                {errors?.[name]?.message}
              </FormFeedback>
            </InputGroup>
          </FormGroup>
        )
      }}
    />
  )
}

export default ICSDateInput

type ICSDateInputProps<TFieldValues extends FieldValues = FieldValues> = {
  id?: string
  name: string
  control?: Control<TFieldValues>
  errors?: FieldErrors<TFieldValues>
  defaultValue?: string
  isSubmitted?: boolean
  label: string
  placeholder?: string
  getValues?: UseFormGetValues<FieldValues>
  setValue?: UseFormSetValue<TFieldValues>
}
